import { useMemo } from 'react';

export const useNavConfig = (): { title: string; path: string }[] => {
  return useMemo(
    (): { title: string; path: string }[] => [
      // E019: Rebranding - External links commented out
    ],
    []
  );
};
